import en from './en/common';

const resources = {
  en: {
    translation: en,
  },
};

export default resources;